document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.category-tile').forEach((tile) => {
      const img = tile.querySelector('img');
      const originalSrc = img.getAttribute('data-original');
      const hoverSrc = img.getAttribute('data-hover');
      if (hoverSrc) {
        tile.addEventListener('mouseenter', () => img.src = hoverSrc);
        tile.addEventListener('mouseleave', () => img.src = originalSrc);
      }
    });
  });
  
  document.querySelectorAll('.category-grid').forEach((slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;
  
    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
  
    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });
  
    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });
  
    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // scroll speed
      slider.scrollLeft = scrollLeft - walk;
    });
  });